import React from 'react';

export const DashboardsNotConfigured = () => <div>Dashboards are not set up yet!</div>;

export default DashboardsNotConfigured;
